import { Controller } from "@hotwired/stimulus"

// Controle l'upload et la suppression de documents partages en session
export default class extends Controller {
  static targets = ["titleInput", "fileInput", "fileLabel", "submitBtn", "documentsList", "emptyState"]
  static values = {
    uploadUrl: String,
    deleteUrl: String,
    deleteConfirm: { type: String, default: "Supprimer ce document ?" }
  }

  connect() {
    this.observeNewDocuments()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  // --- Upload ---

  async uploadDocument(event) {
    event.preventDefault()

    const form = event.currentTarget
    const formData = new FormData(form)

    if (!this.uploadUrlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = true

    try {
      const response = await fetch(this.uploadUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      })

      if (response.ok) {
        form.reset()
        if (this.hasFileLabelTarget) this.fileLabelTarget.textContent = "Choisir un fichier..."
      } else {
        console.error("[SessionDocument] Upload failed:", response.status)
      }
    } catch (error) {
      console.error("[SessionDocument] Upload error:", error)
    } finally {
      if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = false
    }
  }

  // --- Delete ---

  async deleteDocument(event) {
    event.preventDefault()

    const documentId = event.currentTarget.dataset.documentId
    if (!documentId || !this.deleteUrlValue) return
    if (!confirm(this.deleteConfirmValue)) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(`${this.deleteUrlValue}/${documentId}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (!response.ok) {
        console.error("[SessionDocument] Delete failed:", response.status)
      }
    } catch (error) {
      console.error("[SessionDocument] Delete error:", error)
    }
  }

  // --- File input label update ---

  onFileChange(event) {
    const file = event.currentTarget.files[0]
    if (file && this.hasFileLabelTarget) {
      this.fileLabelTarget.textContent = file.name
    }
  }

  // --- MutationObserver : detecte les nouveaux documents pour badge ---

  observeNewDocuments() {
    if (!this.hasDocumentsListTarget) return

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          this.hideEmptyState()
          this.dispatch("newDocument")
        }
        if (mutation.removedNodes.length > 0) {
          this.checkEmptyState()
        }
      }
    })

    this.observer.observe(this.documentsListTarget, { childList: true })
  }

  hideEmptyState() {
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add("hidden")
    }
  }

  checkEmptyState() {
    if (!this.hasEmptyStateTarget || !this.hasDocumentsListTarget) return

    // Compter les enfants reels (pas le empty state lui-meme)
    const documentCards = this.documentsListTarget.querySelectorAll("[id^='interactive_session_document_']")
    if (documentCards.length === 0) {
      this.emptyStateTarget.classList.remove("hidden")
    }
  }
}
